import React from "react";
import { IMAGE_URL } from "../../../constants";

const PhotoGalleryModal = ({ selectedImage, closeModal }) => {
  return (
    <div
      className="modal gallery-modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
      style={{ display: "block", zIndex: "99999" }}
    >
      
      <div
        className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <section class="  ">
              {/* <p className="fw-bold mb-4" style={{ color: "#2866AD" }}>
                Panasonic
              </p> */}
              <div class="row g-0 ">
                <div
                  className="w-100 d-flex justify-content-center mx-auto"
                  style={
                    {
                      // maxHeight: "500px",
                      // maxWidth: "940px",
                      // height: "100%",
                    }
                  }
                >
                  <img
                    src={`${IMAGE_URL}AlbumImg/${selectedImage}`}
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      // height: "100%",
                    }}
                    className="shadow-1-strong rounded"
                    alt="Selected Image"
                  />
                </div>
                {/* <div
                  class="col-md-12 d-flex flex-column justify-content-between"
                  style={{ backgroundColor: "#F7F7F7" }}
                >
                  <div class="card">
                    <div class="card-body">
                      <h3
                        className="text-left "
                        style={{
                          color: "#0C807D",
                          fontSize: "28px",
                          fontWeight: "500",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        Contrary to popular belief, Lorem Ipsum is not simply
                        random text.
                      </h3>
                      <p class="text-secondary">
                        It has roots in a piece of classical Latin literature
                        from 45 BC, making it over 2000 years old. Richard
                        McClintock,
                      </p>
                      <p class="card-text mt-4 mb-3">
                        A patient of 35 years came to United Hospital with
                        history of Road Traffic Accident and with complaints of
                        inability to close his mouth. Clinical evaluation
                        suggested a possible fracture in the lower jaw; CT scan
                        confirmed initial clinical diagnosis revealing a
                        mandibular midline fracture. Treatment plan was done for
                        open reduction of the mandibular fracture followed by
                        bone plating and intra arch immobilisation. Under GA,
                        fracture site was exposed and reduction was done
                        manually. Fixation was done with two site plating, one
                        at the upper dento alveolar bone and other at the lower
                        border of the mandible. Titanium bone plate and screws
                        were used for fixation. Upper and lower arch bar were
                        used for intra arch immobilisation and occlusion was
                        corrected with wire traction. Follow up traction was
                        applied with elastic traction for 4 weeks. Three month
                        post-operative follow up showed normal occlusion and
                        bite with normal jaw relation. This was a case of
                        mandible midline fracture with deranged occlusion. In
                        such case, bilateral muscle pull in the masticatory area
                        makes the situation unfavorable for fracture reduction
                        as the muscle action tends to open the fracture line in
                        the middle. That’s why two level immobilisation with
                        bone plating is necessary in such cases to prevent
                        fracture reduction failure. Further manual maneuvering
                        of the fracture parts to correct the bite, though
                        difficult, was done by wire pulling with arch bar.
                      </p>

                      <div className="row d-flex justify-content-center align-items-center pt-5">
                        {[
                          "case-img-1.png",
                          "case-img-2.png",
                          "case-img-3.png",
                          "case-img-4.png",
                        ].map((item, index) => (
                          <div className="col-md-3 imgContainer">
                            <img
                              className="image-fluid"
                              style={{ borderRadius: "5px" }}
                              src={`/assets/images/${item}`}
                              alt=""
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoGalleryModal;



// WEBPACK FOOTER //
// ./src/component/frontend/PhotoGalleryNew/PhotoGalleryModal.js